import { render, staticRenderFns } from "./UiSaveButton.vue?vue&type=template&id=5e9bef96"
import script from "./UiSaveButton.vue?vue&type=script&lang=js"
export * from "./UiSaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports